import React, { useState, useEffect,useContext } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { useQuery, useMutation, ClientContext } from "graphql-hooks";
import Layout from "./Layout.js";
import { Grid } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import {project_url, admin_url} from "../store/data/Constants";

import {
  CREATE_FILTER_MUTATION,
  GET_ALL_FILTERS_QUERY
} from "../graphQL/filter_qry";
import { REFRESH_TOKEN_MUTATION } from "../graphQL/user_qry";
// import "../styles.css";
import adminStyle from "./Admin.module.scss";
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

/*##########################################################################
## Function : Filter
## Description : Submit form data and create new record in filter table
## Author : SS
## Date: : 2022/02/26
##########################################################################*/
export default function AddFilter() {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();
  const [successMessage, setSuccessMessage] = useState("");
  const [failedMessage, setFailedMessage] = useState("");
  const [allFilters, setAllFilters] = useState([]);
  const navigate = useNavigate();
  const [createFilter] = useMutation(CREATE_FILTER_MUTATION, {
    refetchQueries: [{ query: GET_ALL_FILTERS_QUERY }],
    awaitRefetchQueries: true
  });
  const { loading, error, data } = useQuery(GET_ALL_FILTERS_QUERY, {
    fetchPolicy: "network-only"
  });
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION,{onError: (err) => {console.log(err);}});
  const client = useContext(ClientContext);
  
  useEffect(() => {
    if(localStorage.getItem("refreshToken")){
		onRefreshToken();
	}
	else
		navigate(`/lms/${admin_url}/signin`);
  }, [])
  
  const onRefreshToken = async () => {
    const { data:refreshData, error:refreshError } = await refreshToken({variables: { refreshToken: localStorage.getItem("refreshToken")}});
	if (refreshError) {
		if(refreshError.graphQLErrors[0].message === "You do not have permission to perform this action")
			navigate(`/lms/${admin_url}/signin`);
		if(refreshError.graphQLErrors[0].message === "Signature has expired")
			navigate(`/lms/${admin_url}/signin`);
	}
	if(refreshData && refreshData.refreshToken) {
		localStorage.setItem("token", refreshData.refreshToken.token);
        localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
        client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
	}
  };

  useEffect(
    () => {
      console.log(loading);
      console.log(error);
      console.log(data);

      if (!loading && data && data.allFilters) {
        console.log(data.allFilters);
        setAllFilters(data.allFilters);
        console.log("AllFiltersData----", data);
      }
      if (error && error.graphQLErrors[0].message === "Signature has expired") {
        navigate(`/lms/${admin_url}/signin`);
      }
    },
    [data]
  );

  /*
   * Function : setTimeout
   * Description : Disappear message after timeout
   */
  setTimeout(() => {
    setSuccessMessage("");
    setFailedMessage("");
  }, 15000);

  /*
   * Function : onSubmit
   * Description : Submit form data
   */
  const onSubmit = async formData => {
    await sleep(2000);

    let findName = allFilters.find(
      item => item.name.toLowerCase() === formData.name.toLowerCase()
    );

    if (findName)
      alert(
        "This filter name has been already exist. Please enter another one."
      );
    else {
      const { data, error } = await createFilter({
        variables: {
          name: formData.name
        }
      });
      if (error) {
        console.log("Error", error, data);
        setFailedMessage("Unfortunately an error occurred.");
        setTimeout("");
      } else if (data && data.createFilter) {
        console.log("Success", data.createFilter);
        allFilters.push(data.createFilter);
        setSuccessMessage("New filter added successfully.");
        setTimeout("");
		navigate(`/lms/${admin_url}/filter`);
      }
    }
  };

  /////////////////////////////////////////////////////////////////////
  return (
    <>
      <Helmet>
        <title>Predictal | Add Filter | Admin</title>
      </Helmet>
      <Grid container direction="row" alignItems="flex-start">
        <Layout />
        <form className={adminStyle.form} onSubmit={handleSubmit(onSubmit)}>
          <h2 className={adminStyle.h2}>Add Filter to "filter" table</h2>

          <label className={adminStyle.label} htmlFor="name">
            Name
          </label>
          <input
            className={adminStyle.input}
            id="name"
            {...register("name", { required: true })}
          />
          {errors.name && errors.name.type === "required" && (
            <span>Required</span>
          )}
          <input className={adminStyle.input} type="submit" />
          {successMessage && (
            <div className={adminStyle.success}>{successMessage}</div>
          )}
          {failedMessage && (
            <div className={adminStyle.error}>{failedMessage}</div>
          )}
        </form>
      </Grid>
    </>
  );
}
